import React from 'react';

import TextButton from 'CommonComponents/TextButton';

import EditIcon from 'Assets/icons/edit.svg';

export default function ScoringCriteriaTableDisplayRow(props) {
    const parseDescription = (description) => {
        return description.split('\n');
    };

    return (
        <tr>
            <td className="!tw-bg-white tw-align-top">{props.criteria.mark}</td>
            <td>
                <ul>
                    {parseDescription(props.criteria.description).map((item, index) => {
                        return <li key={index}>{item}</li>;
                    })}
                </ul>
            </td>
            <td className="inbud-numeric-cell">{props.criteria.score}</td>
            <td>
                {!!props.canEdit && (
                    <TextButton onClick={() => props.editAction()}>
                        <EditIcon className="tw-w-3 tw-h-3" />
                        {$t('Edit')}
                    </TextButton>
                )}
            </td>
        </tr>
    );
}
